

















































































































import { Vue, Component } from "vue-property-decorator";
import { required, email } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { Member } from "../types";
import { User } from "@/modules/auth/types";

const Team = namespace("team");
const Auth = namespace("auth");

@Component({})
export default class EditTeamMember extends Vue {
  @Team.Action("fetchMembers") fetchMembers!: () => Promise<{}>;
  @Team.Action("updateCurrentTeamMember") updateCurrentMember!: (
    payload?: Member
  ) => Promise<{}>;
  @Team.Action("fetchCurrentTeamMember") fetchCurrentTeamMember!: (
    memberId?: string
  ) => Promise<{}>;
  @Team.Getter("getCurrentTeamMember") currentTeamMember: Member;
  @Auth.Getter("getUser") user!: User;
  @Team.Action("fetchSuperAdminCount") fetchSuperAdminCount!: () => Promise<{}>;
  @Team.Getter("getSuperAdminCount") getSuperAdminCount: number;

  loading = false;
  hasError = false;
  superAdminCount = 0;
  teamForm = {
    firstName: "",
    lastName: "",
    email: "",
    role: 0,
    userId: "",
    roleOption: {}
  };

 

  get roleOptions() {
    return this.getSuperAdminCount != 0
      ? [
        { name: "Admin", value: 0 },
        { name: "Developer", value: 1 },
        { name: "Reviewer", value: 2 },
      ]
      : [
        { name: "Admin", value: 0 },
        { name: "Developer", value: 1 },
        { name: "Reviewer", value: 2 },
        { name: "Superadmin", value: 3 },
      ];
  }

  async beforeMount() {
    await this.fetchSuperAdminCount();

    const { memberId } = this.$route.params;
    await this.fetchCurrentTeamMember(memberId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.teamForm.userId = this.currentTeamMember.id!;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.teamForm.role = this.currentTeamMember.role!;
    this.teamForm.firstName = this.currentTeamMember.firstName;
    this.teamForm.lastName = this.currentTeamMember.lastName;
    this.teamForm.email = this.currentTeamMember.email;
    this.teamForm.roleOption = this.roleOptions.find(option => option.value === this.teamForm.role) || {};
  }
  goBack() {
    this.$router.push({ name: "team" });
  }
  displayRoleDropdown() {
    const isAdmin = this.teamForm.role === 0 || this.teamForm.role === 3;
    const isCurrentUser = this.user.id === this.teamForm.userId;
    // Admins should not be able to edit their own role
    return !(isAdmin && isCurrentUser && this.superAdminCount > 0);
  }
  setSelectedRole(payload) {
    const { value } = payload;
    this.teamForm.role = value;
  }
  updateTeamMember() {
    this.loading = true;
    const { memberId } = this.$route.params;
    const { firstName, lastName, email, role } = this.teamForm;

    this.updateCurrentMember({
      id: memberId,
      firstName,
      lastName,
      email,
      role,
    })
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Team member updated successfully.",
        });
        this.goBack();
        this.fetchMembers();
      })
      .catch(() => {
        this.loading = false;
        this.hasError = true;
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to update team member.",
        });
      });
  }
  validations() {
    return {
      teamForm: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          required,
          email,
        },
        role: {
          required,
        },
      },
    };
  }
}
